import { CallState } from "@b2bportal/core-types";
import type { GuestsSelection } from "@b2bportal/lodging-api";
import type { HotelsShopState } from "./types";

export const initialShopGuests: GuestsSelection = {
  adults: 2,
  children: [],
};

export const initialHotelShopState: HotelsShopState = {
  shopCallState: CallState.NotCalled,
  availabilityCallState: CallState.NotCalled,
  isLodgingUnavailable: false,
};
